/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SymbolSplitDto,
    SymbolSplitDtoFromJSON,
    SymbolSplitDtoToJSON,
} from '../models';

export interface SymbolSplitControllerGetBySymbolIdRequest {
    symbolId: string;
}

/**
 * 
 */
export class SymbolSplitsApi extends runtime.BaseAPI {

    /**
     * Get splits by symbol
     */
    async symbolSplitControllerGetBySymbolIdRaw(requestParameters: SymbolSplitControllerGetBySymbolIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<SymbolSplitDto>>> {
        if (requestParameters.symbolId === null || requestParameters.symbolId === undefined) {
            throw new runtime.RequiredError('symbolId','Required parameter requestParameters.symbolId was null or undefined when calling symbolSplitControllerGetBySymbolId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/symbol-splits/{symbolId}`.replace(`{${"symbolId"}}`, encodeURIComponent(String(requestParameters.symbolId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SymbolSplitDtoFromJSON));
    }

    /**
     * Get splits by symbol
     */
    async symbolSplitControllerGetBySymbolId(requestParameters: SymbolSplitControllerGetBySymbolIdRequest, initOverrides?: RequestInit): Promise<Array<SymbolSplitDto>> {
        const response = await this.symbolSplitControllerGetBySymbolIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
